import { create } from "zustand";

interface CategoryFilterState {
	categories: number[];
}
interface CategoryFilterActions {
	addOrRemoveCategory: (categoryId: number) => void;
}

export const useCategoryFilterStore = create<
	CategoryFilterState & CategoryFilterActions
>((set, get) => ({
	categories: [],
	addOrRemoveCategory: (categoryId) => {
		const currentCategories = get().categories;

		const indexCat = currentCategories.findIndex((cat) => cat === categoryId);
		const updateCategories =
			indexCat === -1
				? [...currentCategories, categoryId]
				: currentCategories.filter((cat) => cat !== categoryId);

		set({ categories: updateCategories });
	},
}));

/**
 * Search Post
 */
interface SearchPostsState {
	textSearch?: string;
}
interface SearchPostsActions {
	onSearch: (value: string) => void;
}

export const useSearchPostsStore = create<
	SearchPostsState & SearchPostsActions
>((set, get) => ({
	textSearch: "",
	onSearch: (value) => {
		set({ textSearch: value });
	},
}));
